import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { setAuthOpen } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Fjalëkalimet nuk përputhen"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      toast.success("Fjalëkalimi u rivendos");
    } catch (e2) { toast.error(errMsg(e2)); }
    finally { setLoading(false); }
  };

  return (
    <div className="gs-fade min-h-[70vh] flex items-center justify-center px-4" data-testid="reset-page">
      <div className="w-full max-w-sm bg-white rounded-3xl border border-slate-100 shadow-sm p-6">
        <div className="flex justify-center mb-3"><Logo /></div>
        {!token ? (
          <p className="text-center text-sm text-red-500">Link i pavlefshëm.</p>
        ) : done ? (
          <div className="text-center space-y-3">
            <h1 className="text-xl font-extrabold text-slate-900">Gati! 🎉</h1>
            <p className="text-sm text-slate-500">Fjalëkalimi yt u rivendos. Tani mund të kyçesh.</p>
            <Button data-testid="reset-go-login" onClick={() => { nav("/"); setAuthOpen(true); }} className="w-full h-11 rounded-xl bg-emerald-500 hover:bg-emerald-600 font-semibold">Kyçu</Button>
          </div>
        ) : (
          <>
            <h1 className="text-xl font-extrabold text-slate-900 text-center">Rivendos fjalëkalimin</h1>
            <p className="text-sm text-slate-500 text-center mb-4">Vendos një fjalëkalim të ri për llogarinë tënde.</p>
            <form onSubmit={submit} className="space-y-3">
              <Input data-testid="reset-pw" type="password" placeholder="Fjalëkalimi i ri" value={pw} onChange={(e) => setPw(e.target.value)} required className="rounded-xl h-11" />
              <Input data-testid="reset-pw2" type="password" placeholder="Konfirmo fjalëkalimin" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="rounded-xl h-11" />
              <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full h-11 rounded-xl bg-emerald-500 hover:bg-emerald-600 font-semibold">{loading ? "Duke ruajtur..." : "Rivendos"}</Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
